import { formatDate } from "@/utils/helper";
import SkillTag from "./SkillTag";

export default function ListItem({ candidate, onOpen }) {
  return (
    <div className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow duration-200">
      <div className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-medium text-gray-900">
              {candidate.name || "N/A"}
            </h3>
            <p className="text-sm text-gray-500">
              {candidate.contact?.email || ""}
            </p>
          </div>
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
            {candidate.total_years_experience
              ? `${candidate.total_years_experience} 年经验`
              : "经验未知"}
          </span>
        </div>

        <div className="mt-4">
          <p className="text-sm font-medium text-gray-900">
            {candidate.title || "职位未知"}
          </p>
          <div className="mt-2">
            <h4 className="text-xs font-medium text-gray-500 uppercase tracking-wider">
              核心技能
            </h4>
            <div className="mt-1 flex flex-wrap gap-1">
              {candidate.core_skills.slice(0, 3).map((skill, index) => <SkillTag key={index}>{skill}</SkillTag>)}
              {candidate.core_skills.length > 3 && (
                <span className="text-xs text-gray-400">
                  +{candidate.core_skills.length - 3}
                </span>
              )}
              {candidate.core_skills.length === 0 && (
                <span className="text-xs text-gray-400 italic">无</span>
              )}
            </div>
          </div>
        </div>

        <div className="mt-6 flex items-center justify-between">
          <div className="text-sm text-gray-500">
            {formatDate(candidate.created_at)}
          </div>
          <button
            onClick={() => onOpen(candidate)}
            className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            查看详情
          </button>
        </div>
      </div>
    </div>
  );
}
